import {
  dashboardFilter,
  dashboardKpis,
  dashboardWidgets,
  energyCommunityColumns,
  energyCommunityFilter,
  energyCommunityWidgets,
} from 'conf/pages';
import { routes } from 'consts/routes';
import { EnelXGuiIcons } from 'gui';

export const TEMPLATE_PAGE_DASHBOARD = 'dashboard';
export const TEMPLATE_PAGE_ENERGY_COMMUNITY = 'energyCommunity';
export const TEMPLATE_PAGE_GLOBAL = 'global';

const {
  DesktopIcon,
  SolarPanelIcon,
} = EnelXGuiIcons;

export const TEMPLATE_MAPPER = {
  [TEMPLATE_PAGE_DASHBOARD]: {
    starMenu: {
      goToLink: routes.dashboard.root,
      Icon: DesktopIcon,
      label: 'navigation.homepage',
    },
    conf: {
      filters: dashboardFilter,
      widgets: dashboardWidgets,
      kpis: dashboardKpis,
    },
  },
  [TEMPLATE_PAGE_ENERGY_COMMUNITY]: {
    starMenu: {
      goToLink: routes.energyCommunity.root,
      Icon: SolarPanelIcon,
      label: 'navigation.energyCommunity',
      size: '25px',
    },
    conf: {
      columns: energyCommunityColumns,
      filters: energyCommunityFilter,
      widgets: energyCommunityWidgets,
    },
  },
  [TEMPLATE_PAGE_GLOBAL]: {
    conf: {},
  },
};

export default { TEMPLATE_MAPPER };
